/**
 * Containers for Change - Don't Feed the Fill
 * David Woodward
 **/

// SCSS Imports
import '../scss/main.scss';

// Bin Imports
import {ready} from './bin/tools';
import {collectAllVideos} from './bin/elements';

// Viewport Imports
import {createFullpageRebuildDaemon} from './bin/viewport';

// Component Imports
import {attachCloseEventsToModals} from './components/modals/modal';
import {attachOpenEventsToBlips} from './components/modals/blips';
import {initialiseApplicationNavigation} from './components/navigation/application';
import {initialiseDecision} from './components/decision';
import {initialiseForm} from './components/form';
import {resetDesktopCTAState, attachResetDesktopCTAStateEvents} from './components/navigation/desktop';
import {
  resetMobileNavigationState,
  attachResetMobileNavigationStateEvents,
  attachMobileNavigationButtonEvents,
} from './components/navigation/mobile';

// Animation Imports
import {initialiseBinChicken1} from './animation/iconography/bin-chicken-1';
import {initialiseBinChicken2} from './animation/iconography/bin-chicken-2';
import {initialiseBlips} from './animation/blips';
import {initialiseBottle} from './animation/iconography/bottle';
import {initialiseCounter, playTimelines} from './animation/counter';
import {initialiseGirl} from './animation/iconography/girl';
import {initialiseGirlAndDog} from './animation/iconography/girl-and-dog';
import {initialisePledge} from './animation/pledge';
import {initialiseTimelines} from './animation/initialise';

// node_modules Imports
// fullpage.js - https://alvarotrigo.com/fullPage/
import Fullpage from 'fullpage.js';

let hasBeenClicked = false;

let wasClicked = (a) => {
  if (a == true) {
    hasBeenClicked = true;
    return true;
  } else {
    hasBeenClicked = false;
    return false;
  }
};

/**
 * Removes the loading overlay visibly from the viewport.
 * @param {Boolean} debug Determines if the overlay should be revealed.
 */
const removeOverlayFromViewport = (debug = false) => {
  // Exit early if in debug mode.
  if (debug) return;
  document.getElementById('js:overlay').classList.add('overlay--loaded');
};

/**
 * Iterates through an Array of videos and attempts to play them.
 * @deprecated Currently unused.
 */
const playAllVideos = () => {
  collectAllVideos().forEach((video) => {
    video.play();
  });
};

/**
 * Initialises the fullpage.js system with the provided element.
 */
const initialiseFullpage = (id) => {
  new Fullpage(id, {
    allowScrolling: false,
    anchors: ['home', 'problem', 'prompt', 'depo', 'pledge'],
    controlArrows: false,
    licenseKey: '4AE7B90A-92FC4CFC-A0F02AC9-15AC9088',
    loopHorizontal: false,
    navigation: true,
    sectionsColor: ['#1e855a', '#1e855a', '#1e855a', '#1e855a', '#1e855a'],
    touchSensitivity: false,
    verticalCentered: false,
    lockAnchors: true,
    onLeave: (origin, destination, direction) => {
      if (hasBeenClicked) {
        return true;
      } else if (destination.anchor == 'pledge') {
        fullpage_api.moveTo('depo', 2);
        return false;
      } else if (direction == 'up' && destination.anchor == 'prompt') {
        fullpage_api.moveTo('depo', 1);
        return false;
      }
    },
    onSlideLeave: (section, origin, destination, direction) => {
      if (section.anchor == 'depo' && destination.index == 2) {
        playTimelines();
      }
    },
  });
};

/**
 * Initialise the application.
 */
const initialise = () => {
  // Preemptively determine if the viewport exceeds the mobile width.
  resetMobileNavigationState();
  resetDesktopCTAState();

  // Attach the required event listeners to automate the navigation reset
  // process from herein.
  attachResetMobileNavigationStateEvents();
  attachResetDesktopCTAStateEvents();

  // Attach navigation control event listeners for control elements.
  attachMobileNavigationButtonEvents();

  // Initialise fullpage.js.
  initialiseFullpage('#fullpage');

  // Craete a resize daemon for fullpage.js.
  createFullpageRebuildDaemon();

  // Initialise application-level navigation.
  initialiseApplicationNavigation();

  // Initialise animation timelines.
  initialiseTimelines();

  // Initialise blips and modal control.
  attachCloseEventsToModals();
  attachOpenEventsToBlips();

  // Initialise pledge form.
  initialisePledge();

  // Initialise counter element.
  initialiseCounter();

  // Initialise blip animations.
  initialiseBlips();

  // Initialise decision control.
  initialiseDecision();

  // Initialise form control.
  initialiseForm();

  // Initialise Girl
  initialiseGirl();
  initialiseGirlAndDog();

  // Initialise Bin Chicken 1
  initialiseBinChicken1();

  // Initialise Bin Chicken 2
  initialiseBinChicken2();

  initialiseBottle();

  // Remove the loading overlay once elements have been given an opportunity to
  // initialise and correct themselves.
  removeOverlayFromViewport();

  // Once the page has loaded, attach the video events.
  document.getElementsByClassName('js--play-video')[0].addEventListener('click', () => {
    player.playVideo();
  });
};

// Begin the application.
ready(initialise);

exports.wasClicked = wasClicked;
